import { Avatar, Group, Paper, Text } from '@mantine/core';
import React from 'react';
import { getFullNameInitials } from '../../../utils/get-full-name-initials';
import { clickablePaperSx } from '../styles';

interface UserItemProps {
  u: any;
  onSelect: (u: any) => void;
}

export const UserItem = React.memo(function UserItem({
  u,
  onSelect,
}: UserItemProps) {
  return (
    <Paper withBorder p="xs" sx={clickablePaperSx} onClick={() => onSelect(u)}>
      <Group spacing="xs">
        <Avatar src={u.avatarUrl} size="sm" radius="xl" color="blue">
          {!u.avatarUrl && getFullNameInitials(u.name || u.username)}
        </Avatar>
        <Text weight={500} size="sm">
          {u.name}
        </Text>
      </Group>
    </Paper>
  );
});
